module.exports = __webpack_public_path__ + "img/up-circle.7c697f47.svg";